const HOME_API_BASE_PATH = "home-ia";

export const HOME_API_ROUTES = {
  DECISIONS: `${HOME_API_BASE_PATH}/decisions`,
  PULSE: `${HOME_API_BASE_PATH}/pulse`,
  DATES_SUMMARY: `${HOME_API_BASE_PATH}/dates/summary`,
  METRICS: `${HOME_API_BASE_PATH}/metrics`,
  LAST_ACTIVITY: `${HOME_API_BASE_PATH}/activity/last-activity`,
  ACTIVITY: `${HOME_API_BASE_PATH}/activity`,
  ACTIVITY_HISTORY: `${HOME_API_BASE_PATH}/activity/activity-history`,
  KNOWLEDGE_ATTENTION: `${HOME_API_BASE_PATH}/knowledge-attention`,
  RECENT_CHANGES: `${HOME_API_BASE_PATH}/recent-changes`,
  // Capacidades de entidad (H10/H12): el entityId viaja en la ruta; account/user por el JWT.
  ENTITY_SUGGESTED_QUESTIONS: (entityId: string): string =>
    `${HOME_API_BASE_PATH}/entities/${encodeURIComponent(entityId)}/suggested-questions`,
  ENTITY_GENERATION_SOURCES: (entityId: string): string =>
    `${HOME_API_BASE_PATH}/entities/${encodeURIComponent(entityId)}/generation-sources`
} as const;
